<div class="relative">
  <ngx-spinner name="payment" type="timer"></ngx-spinner>
  <ng-content *ngIf="amount"></ng-content>
</div>

<ngx-smart-modal #paymentHelpModal identifier="paymentHelpModal">
  <div class="d-flex flex-column container-capped-xs f-initial py-2">
    <h5>ارسال لینک پرداخت</h5>
    <div>در صورتی که رمز دوم یا رمز پویای کارت خود را ندارید و امکان پرداخت کارت به کارت از طریق نرم‌افزارهای
      انتقال وجه مانند همراه‌بانک، آپ و... را ندارید، می‌توانید آدرس زیر را برای یکی از اعضای خوانواده،
      همکاران یا دوستان خود ارسال کنید تا وی پرداخت را از طرف شما انجام دهد.</div>
    <div copy>{{paymentLink}}</div>
    <button type="button" class="btn btn-primary m-1 w-100 flex-column" [share]="paymentLink">اشتراک گذاری آدرس</button>
  </div>
</ngx-smart-modal>

<ngx-smart-modal customClass="" #paymentModal identifier="paymentModal">
  <div class="d-flex flex-column container-capped-xs f-initial text-right py-2">
    <div class="border-bottom mb-3">
      <!-- <div class="text-center green-bg f-white fw-bold fs-lg">پرداخت شما ضمانت بازگشت وجه دارد!</div> -->
      <h5 class="kp-title-line mb-2">
        یک روش رو از زیر انتخاب کن 
      </h5>
    </div>
    <!-- <div class="kp-card kp-card-border fw-bold fs-lg text-center">
      پرداخت مبلغ {{amount|number}} تومان <br/> معادل {{amount*10|number}} ریال
    </div> -->
    <div class="mb-2 pb-2 border-bottom pointer" (click)="pay()">
      <div class="h6">پرداخت از طریق درگاه اینترنتی</div>
      <div class="text-left ">
        <button type="button" class="btn btn-primary my-2 flex-column">پرداخت آنلاین </button>
      </div>
      <div class="f-gray">توجه: نیاز به رمز دوم یا رمز پویا دارد.</div>
      <!-- <label class="toggle-switch-container d-flex align-items-center pointer m-0">
          <div class="toggle-switch ml-2">
            <input type="checkbox" name="offline-payment" [(ngModel)]="showOfflinePayment">
            <span class="slider round"></span>
          </div>
          <span>رمز دوم یا رمز پویا ندارم</span>
        </label> -->
    </div>
    <ng-container *ngIf="showOfflinePayment">
      <div class="mb-2 py-2 pointer" (click)="manualModal.open()">
        <div class="h6">پرداخت از طریق کارت به کارت</div>
        <div class="f-gray">از طریق <b>دستگاه خودپرداز(ATM)</b> یا نرم‌افزارهای انتفال وجه مانند
          <b>آپ و همراه کارت و ...</b>
        </div>
        <div class="text-left ">
          <button type="button" class="btn btn-primary my-2 flex-column">پرداخت کارت به کارت </button>
        </div>
      </div>
      <!-- <div class="mb-2 py-2 border-bottom">
        <div class="h6">خودتان نمی‌توانید پرداخت کنید؟</div>
        <div class="f-gray">اگر می‌خواهید برای پرداخت از یکی از آشنایانتان کمک بگیرید این گزینه را انتخاب کنید.</div>
        <div class="text-left ">
          <button type="button" class="btn btn-secondary my-2 flex-column" (click)="makePayment()">ارسال لینک خرید</button>
        </div>
      </div> -->
    </ng-container>
  </div>
</ngx-smart-modal>

<app-manual-payment-modal #manualModal [amount]="amount" (submitPayment)="pay($event)"></app-manual-payment-modal>